<template>
  <div class="ttshop_user">
    <Header></Header>
    <Nav></Nav>
    <div class="ttshop_user">
      <div class="ttshop_usercon w clearfloat">
        <div class="ttshop_orderxq">
          <!-- 面包屑 -->
          <div class="ttshop_ordernav clearfloat">
            <p class="ttshop_navtext" @click="goTtshop_usermyorder">订单中心</p>
            <span>&gt;</span>
            <p class="ttshop_orderdh">订单：<strong>{{id}}</strong></p>
          </div>
          <!-- 我要换货/退货(商家同意后) -->
          <div class="ttshop_orderdzf clearfloat">
            <div class="ttshop_orderdzfleft d-flex align-items-center justify-content-center">
              <h4>
                <template v-if="list.refund_type==1">
                  <template v-if="list.refund_status==0">
                    <template v-if="list.is_agree==0">等待审核中</template>
                    <template v-else>
                      <template v-if="list.is_user_send==0">已同意退货，请及时发货</template>
                      <template v-else>已发货，待平台确认</template>
                    </template>
                  </template>
                  <template v-if="list.refund_status==1">已同意退货并已退款</template>
                  <template v-if="list.refund_status==3">已拒绝退货</template>
                </template>

                <template v-if="list.refund_type==2">
                  <template v-if="list.refund_status==0">
                    <template v-if="list.is_agree==0">等待审核中</template>
                    <template v-else>
                      <template v-if="list.is_user_send==0">已同意换货，请及时发货</template>
                      <template v-else>已发货，待平台确认</template>
                    </template>
                  </template>
                  <template v-if="list.refund_status==1">已同意换货</template>
                  <template v-if="list.refund_status==2">卖家已发货</template>
                  <template v-if="list.refund_status==3">已拒绝换货</template>
                </template>
              </h4>
            </div>
            <div class="ttshop_orderdzfright">
              <ul class="clearfloat">
                <li class="active">
                  <h5>1</h5>
                  <p>申请{{list.refund_type ==2?'换货':'退货退款'}}</p>
                  <span></span>
                </li>
                <li v-if="list.is_agree == 0">
                  <h5>2</h5>
                  <p>等待商家同意</p>
                  <span></span>
                </li>
                <li v-if="list.is_agree != 0" class="active">
                  <h5>2</h5>
                  <p>{{list.is_agree == 1?'商家同意':'商家已拒绝'}}</p>
                  <span></span>
                </li>
                <li v-if="list.is_agree != 2" :class="{active:list.is_user_send == 1}">
                  <h5>3</h5>
                  <p>买家发货</p>
                  <span></span>
                </li>
				<!-- v-if="list.refund_type ==1 &&list.is_agree != 2" -->
                <li :class="{active:list.is_user_send == 1}">
                  <h5>4</h5>
                  <p>商家收货</p>
                  <span></span>
                </li>
                <li v-if="list.is_agree != 2" :class="{active:list.is_user_send == 1}">
                  <h5>5</h5>
                  <p>已完成</p>
                  <span></span>
                </li>
              </ul>
            </div>
          </div>

          <!-- 商品信息 -->
          <div class="ttshop_barteragreeshop">
            <div class="ttshop_barternav clearfloat">
              <p class="ttshop_bartershop">商品信息</p>
              <p class="ttshop_barterdj">单价(分)</p>
              <p class="ttshop_barterdj">数量</p>
              <p class="ttshop_barterdj">支付积分</p>
            </div>
            <div class="ttshop_bartercon">
              <div class="ttshop_barterlist">
                <!-- <div class="ttshop_barterlistitle clearfloat">
                  <p>2019-08-20 11:55:41</p>
                  <p>订单号：<span>127830913797</span></p>
                  <p>卖家：<strong>太平鸟官方旗舰店</strong></p>
                </div> -->
                <div class="ttshop_barterlistcon clearfloat">
                  <div class="ttshop_bartershoping clearfloat">
                    <div class="ttshop_barterimg">
                      <img class="img-default" :src="list.goods_pic" alt="">
                    </div>
                    <div class="ttshop_bartertext">
                      <h5>{{list.name}}</h5>
                      <span v-for="(attr,ids) in list.attr" :key="ids">{{attr.attr_group_name}}:<strong>{{attr.attr_name}}</strong></span>
                    </div>
                  </div>
                  <div class="ttshop_barterdjer">
                    <p> {{list.total_price}}</p>
                  </div>
                  <div class="ttshop_barterdjer">
                    <p>{{list.num}}</p>
                  </div>
                  <div class="ttshop_barterdjer">
                    <p> {{list.total_price}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 收货人信息 -->
          <div class="ttshop_barteragreebut">
            <h4 v-if="list.refund_status == 0 && list.is_agree != 0 || list.refund_status == 2">收货人信息</h4>
            <div class="ttshop_barteragreelist clearfloat">
              <div class="ttshop_barteragreeleft" v-if="list.refund_status == 0 && list.is_agree != 0 || list.refund_status == 2">
                <h5>收件人 : {{list.re_name}}</h5>
                <h5><span>电话</span> : {{list.re_mobile}}</h5>
                <h5><span>地址</span> : {{list.re_address}}</h5>
                <ul v-if="list.is_user_send==0">
                  <li class="clearfloat">
                    <span>快递公司：</span>
                    <div class="ttshop_bartersele">
                      <el-select v-model="value" placeholder="选择快递公司" @change="exprchange">
                        <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </li>
                  <li class="clearfloat">
                    <span>快递单号：</span>
                    <div class="ttshop_bartersele">
                      <input type="text" v-model="express_no" placeholder="输入快递单号">
                    </div>
                  </li>
                  <li>
                    <button @click="refundSend">提交</button>
                  </li>
                </ul>
                <template v-else>
                  <template v-if="list.user_send_express">
                    <h4 class="wl">发货物流</h4>
                    <h5>快递公司 : {{list.user_send_express}}</h5>
                    <h5>快递单号 : {{list.user_send_express_no}}</h5>
                  </template>
                  <template v-if="list.return_express">
                    <h4 class="wl">收货物流</h4>
                    <h5>快递公司 : {{list.return_express}}</h5>
                    <h5>快递单号 : {{list.return_express_no}}</h5>
                  </template>
                </template>

              </div>
              <div class="ttshop_barteragreeright">
                <p class="clearfloat"><strong>售后类型：</strong><span>{{list.refund_type==1?'退货退款':'换货'}} </span></p>
                <p class="clearfloat"><strong>申请原因：</strong><span>{{list.refund_desc}}</span></p>
                <p class="clearfloat" v-if="list.refund_price && list.refund_price > 0"><strong>退款积分：</strong><span>{{list.refund_price}}</span></p>
                <ul class="clearfloat">
                  <li v-for="(item,index) in list.refund_pic_list" :key="index"><img class="img-default" :src="item" alt=""></li>
                </ul>
                <p v-if="list.refund_status==3" class="clearfloat"><strong>拒绝原因：</strong><span>{{list.refuse_desc}}</span></p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/purchase/header/header";
import Nav from "@/components/purchase/nav/nav";
import Footer from "@/components/purchase/footer/footer";
export default {
  components: {
    Header,
    Nav,
    Footer
  },
  data() {
    return {
      options: [],
      value: "",
      id: this.$route.query.id,
      list: "",
      express_no: "",
      optionsname:'',//选中的快递公司名称
    };
  },
  mounted() {
    this.refundDetail();
  },
  methods: {
    exprchange(value){
      for(var i=0;i<this.options.length;i++){
        if(value==this.options[i].id){
          this.optionsname=this.options[i].name
        }
      }
      console.log(this.optionsname);
    },
    //去列表
    goTtshop_usermyorder() {
    	this.$router.replace(this.common.qycgrouter(this) + "/ordercenter");
    },
    refundDetail() {
      this.$api
        .shdetails({
			order_type: "SHOP",
			order_refund_id: this.id,
			access_token : this.$store.state.qycg_user.access_token,
        })
        .then((res) => {
          console.log(res.data);
          this.list = res.data;
          this.options = res.data.express_list;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    refundSend() {
      // console.log(this.value, this.express_no);
      if (!this.value) {
        this.$message({
          type: "success",
          message: "请选择快递公司",
          showClose: true,
          offset: 200,
          duration: 1000,
        });
        return false;
      }
      if (!this.express_no) {
        this.$message({
          type: "success",
          message: "请填写快递单号",
          showClose: true,
          offset: 200,
          duration: 1000,
        });
        return false;
      }
      // console.log(this.optionsname);
      // console.log(value);
      let url='';
      if(this.list.or_type==3){
        // url=this.$api.refund_send
        this.Alibabashop();
      }else{
        this.merchandise()
      }
      // console.log(url);
      
    },
    //普通商品的售后
    merchandise(){
      this.$api
        .shfahuo({
          order_refund_id: this.id,
          express: this.optionsname,
          express_no: this.express_no,
          orderType: "STORE",
		  access_token : this.$store.state.qycg_user.access_token,
        })
        .then((res) => {
          // console.log(res.data);
          this.$message({
            type: "success",
            message: res.msg,
            showClose: true,
            offset: 200,
            duration: 1000,
          });
          this.refundDetail();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //1688商品的售后
    Alibabashop(){
      this.$api
        .refund_send({
          order_refund_id: this.id,
          express: this.optionsname,
          express_no: this.express_no,
          companyNo:this.value
        })
        .then((res) => {
          // console.log(res.data);
          this.$message({
            type: "success",
            message: res.msg,
            showClose: true,
            offset: 200,
            duration: 1000,
          });
          this.refundDetail();
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style  lang="scss" scoped>
.ttshop_orderxq {
  width: 100%;
  .ttshop_ordernav {
    width: 100%;
    margin-bottom: 20px;
    .ttshop_navtext {
      float: left;
      cursor: pointer;
      font-size: 12px;
      color: #333;
      transition: 0.5s;
      -moz-transition: 0.5s;
      -webkit-transition: 0.5s;
      -o-transition: 0.5s;
      &:hover {
        color: #ff0e25;
      }
    }
    span {
      float: left;
      font-size: 12px;
      color: #333;
      margin: 0 5px;
    }
    .ttshop_orderdh {
      float: left;
      font-size: 12px;
      color: #333;
      strong {
        font-size: 12px;
        color: #333;
        font-weight: 400;
      }
    }
  }
  .ttshop_orderdzf {
    width: 100%;
    height: 200px;
    background: #fff;
    margin-bottom: 20px;
    .ttshop_orderdzfleft {
      float: left;
      width: 290px;
      height: 200px;
      background: #ff9010;
      padding: 32px;
      box-sizing: border-box;
      h4 {
        font-size: 20px;
        color: #fff;
        font-weight: 500;
        text-align: center;
      }
    }
    .ttshop_orderdzfright {
      float: left;
      width: 900px;
      height: 200px;
      background: #fff;
      padding: 66px 30px;
      box-sizing: border-box;
      ul {
        li {
          width: 20%;
          float: left;
          position: relative;
          h5 {
            display: block;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            background: #ebebeb;
            text-align: center;
            line-height: 24px;
            font-size: 14px;
            color: #999;
            font-weight: 500;
            margin: 0 auto 13px;
            position: relative;
            z-index: 10;
          }
          p {
            font-size: 12px;
            color: #999;
            text-align: center;
            margin-bottom: 8px;
          }
          span {
            display: block;
            text-align: center;
            font-size: 12px;
            color: #999;
            height: 16px;
          }
          &.active::before {
            background: #ff9010;
          }
          &.active h5 {
            background: #ff9010;
            color: #fff;
          }
          &.active p {
            color: #ff9010;
          }
          &:first-child::before {
            width: 50%;
            left: 57%;
            top: 14%;
            transform: translateX(0%);
          }
          &::before {
            content: "";
            position: absolute;
            top: 14%;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
            height: 2px;
            background: #ebebeb;
          }
		  &:last-child:before{
			  left: 0;
			  width: 50%;
			  transform: translateX(0%);
		  }
        }
      }
    }
  }
  .ttshop_barteragreeshop {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    background: #fff;
    margin-bottom: 20px;
    .ttshop_barternav {
      width: 100%;
      height: 32px;
      background: #f5f5f5;
      margin-bottom: 20px;
      .ttshop_bartershop {
        float: left;
        width: 40%;
        font-size: 12px;
        color: #333;
        padding-top: 8px;
        padding-left: 20px;
        box-sizing: border-box;
      }
      .ttshop_barterdj {
        float: left;
        width: 20%;
        font-size: 12px;
        color: #333;
        padding-top: 8px;
        box-sizing: border-box;
        text-align: center;
      }
    }
    .ttshop_bartercon {
      width: 100%;
      .ttshop_barterlist {
        width: 100%;
        .ttshop_barterlistitle {
          width: 100%;
          height: 32px;
          background: #f5f5f5;
          padding: 0 20px;
          box-sizing: border-box;
          p {
            float: left;
            font-size: 12px;
            color: #999;
            padding-top: 8px;
            box-sizing: border-box;
            margin-right: 24px;
            &:last-child {
              margin-right: 0;
            }
            span {
              font-size: 12px;
              color: #999;
            }
            strong {
              font-size: 12px;
              color: #333;
              font-weight: 500;
            }
          }
        }
        .ttshop_barterlistcon {
          width: 100%;
          height: 113px;
          border: 1px solid #ebebeb;
          box-sizing: border-box;
          .ttshop_bartershoping {
            float: left;
            width: 40%;
            height: 113px;
            padding: 16px 20px;
            box-sizing: border-box;
            border-right: 1px solid #ebebeb;
            .ttshop_barterimg {
              float: left;
              width: 80px;
              height: 80px;
              margin-right: 12px;
              img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
            .ttshop_bartertext {
              float: left;
              width: 75%;
              h5 {
                font-size: 12px;
                color: #333;
                line-height: 18px;
                font-weight: 400;
                margin-bottom: 8px;
              }
              span {
                font-size: 12px;
                color: #999;
                margin-right: 5px;
                strong {
                  font-size: 12px;
                  color: #999;
                  font-weight: 400;
                }
                &:last-child {
                  margin-right: 0;
                }
              }
            }
          }
          .ttshop_barterdjer {
            float: left;
            width: 20%;
            height: 113px;
            padding: 16px 20px;
            box-sizing: border-box;
            border-right: 1px solid #ebebeb;
            &:last-child {
              border-right: 0;
            }
            p {
              font-size: 12px;
              color: #333;
              font-weight: 400;
              line-height: 18px;
              text-align: center;
            }
          }
        }
      }
    }
  }
  .ttshop_barteragreebut {
    width: 100%;
    padding: 24px 20px;
    box-sizing: border-box;
    background: #fff;
    h4 {
      font-size: 16px;
      color: #999;
      font-weight: 500;
      line-height: 16px;
      margin-bottom: 28px;
    }
    .ttshop_barteragreelist {
      width: 100%;
      .ttshop_barteragreeleft {
        float: left;
        width: 48%;
        margin-right: 4%;
        .wl {
          font-size: 16px;
          color: #999;
          font-weight: 500;
          line-height: 16px;
          margin-top: 10px;
          margin-bottom: 0;
        }
        h5 {
          font-size: 12px;
          color: #333;
          font-weight: 400;
          line-height: 32px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          span {
            // letter-spacing: inherit;
            // word-spacing: 10px;
            letter-spacing: 12px; /*如果需要y个字两端对齐，则为(x-y)/(y-1),这里是（4-2）/(2-1)=2em */
            margin-right: -12px;
          }
        }
        ul {
          margin-top: 20px;
          li {
            margin-bottom: 16px;
            span {
              float: left;
              width: 60px;
              font-size: 12px;
              color: #333;
              margin-right: 16px;
              line-height: 28px;
            }
            .ttshop_bartersele {
              float: left;
              width: 300px;
              height: 28px;
              box-sizing: border-box;
              input {
                width: 100%;
                height: 28px;
                padding: 0 12px;
                border: 1px solid #ebebeb;
                box-sizing: border-box;
                border-radius: 4px;
                font-size: 12px;
                color: #333;
                outline: none;
                transition: 0.5s;
                -moz-transition: 0.5s;
                -webkit-transition: 0.5s;
                -o-transition: 0.5s;
                &:focus {
                  border-color: #ff0e25;
                }
              }
            }
            button {
              display: block;
              width: 116px;
              height: 32px;
              font-size: 14px;
              color: #fff;
              border-radius: 2px;
              outline: none;
              border: 0;
              margin-top: 46px;
              cursor: pointer;
              background: #ff0e25;
              transition: 0.5s;
              -moz-transition: 0.5s;
              -webkit-transition: 0.5s;
              -o-transition: 0.5s;
              &:hover {
                box-shadow: 0 0 10px rgba(255, 14, 37, 0.3);
              }
            }
          }
        }
      }
      .ttshop_barteragreeright {
        float: left;
        width: 48%;
        p {
          font-size: 12px;
          color: #333;
          padding-top: 7px;
          margin-bottom: 7px;
          box-sizing: border-box;
          strong {
            float: left;
            width: 60px;
            font-size: 12px;
            color: #333;
            font-weight: 500;
            margin-right: 16px;
          }
          span {
            float: left;
            width: 82%;
            font-size: 12px;
            color: #333;
          }
        }
        ul {
          margin-top: 20px;
          li {
            float: left;
            width: 60px;
            height: 60px;
            margin-right: 12px;
            &:last-child {
              margin-right: 0;
            }
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }
      }
    }
  }
}
</style>
